import { Router } from "@reach/router";

import ExerciseDetails from "../components/Stationen/ExerciseDetails";
import Feed from "../components/Feed/Feed";
import Profile from "../components/Profile/Profile";
import ProfileSettings from "../components/Profile/ProfileSettings";
import Accessibility from "../components/Profile/Accessibility";
import Station from "../components/Stationen/Station";
import Stationen from "../components/Stationen/Stationen";
import ExerciseScreen from "../components/Stationen/ExerciseScreen";
import Badges from "../components/Badges/Badges";
import Notification from "../components/Feed/Notification";
import Follow from "../components/Follow";
import Statistics from "../components/Profile/Statistics";

const ProtectedRoutes = () => (
  <Router primary={false}>
    <Notification path="mitteilung" />
    <Stationen path="stationen" />
    <Station path="stationen/:stNr" />
    <ExerciseDetails path="stationen/:stNr/:exName" />
    <ExerciseScreen path="stationen/:stNr/:exName/excercise" />
    <Feed path="feed" />
    <Profile path="profile" />
    <ProfileSettings path="settings" />
    <Statistics path="statistik" />
    <Accessibility path="accessibility" />
    <Badges path="erfolge" />
    <Follow path="follow" />
  </Router>
);

export default ProtectedRoutes;
